import axios from "axios";
import axiosInstance from "../../utils/axiosInstance";
import { BASE_URL } from "../../constant/staticUrl";
const API = axios.create({ baseURL: BASE_URL });



  


  export const getAllAssignmentApi = (formData) =>
    axiosInstance.get(`/admin/assignment/get-all`, formData);
  
  export const uploadAssignmentApi=(formData)=>
    axiosInstance.post('/admin/assignment/upload',formData)

  export const deleteAssignmentApi=(id)=>
    axiosInstance.delete(`/admin/assignment/delete/${id}`)

  export const updateAssignmentApi=(id,formData)=>
    axiosInstance.post(`/admin/assignment/update/${id}`,formData)